import { PropsWithChildren, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from '@material-ui/core';
import HomeIcon from '@material-ui/icons/Home';
import CategoryIcon from '@material-ui/icons/Category';
import LibraryBooks from '@material-ui/icons/LibraryBooks';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline';
import LogoFull from '../../logos/idp-logo.svg';
import LogoIcon from '../../logos/idp-logo-icon.png';
import {
  Settings as SidebarSettings,
  UserSettingsSignInAvatar,
} from '@backstage/plugin-user-settings';
import { SidebarSearchModal } from '@backstage/plugin-search';
import {
  Sidebar,
  sidebarConfig,
  SidebarDivider,
  SidebarGroup,
  SidebarItem,
  SidebarPage,
  SidebarScrollWrapper,
  SidebarSpace,
  useSidebarOpenState,
  Link,
} from '@backstage/core-components';
import MenuIcon from '@material-ui/icons/Menu';
import SearchIcon from '@material-ui/icons/Search';
import { MyGroupsSidebarItem } from '@backstage/plugin-org';
import GroupIcon from '@material-ui/icons/People';
// import { NotificationsSidebarItem } from '@backstage/plugin-notifications';
import { recordVisit } from '../home/visitHistory';
import { RequirePermission } from '@backstage/plugin-permission-react';
import { taskCreatePermission } from '@backstage/plugin-scaffolder-common/alpha';

const useSidebarLogoStyles = makeStyles({
  root: {
    width: sidebarConfig.drawerWidthClosed,
    height: 3 * sidebarConfig.logoHeight,
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
    marginBottom: -14,
  },
  link: {
    width: sidebarConfig.drawerWidthClosed,
    marginLeft: 24,
  },
});

const SidebarLogo = () => {
  const classes = useSidebarLogoStyles();
  const { isOpen } = useSidebarOpenState();

  return (
    <div className={classes.root}>
      <Link to="/" underline="none" className={classes.link} aria-label="Home">
        {isOpen ? <img src={LogoFull} /> : <img src={LogoIcon} />}
      </Link>
    </div>
  );
};

const VisitTracker = () => {
  const location = useLocation();

  useEffect(() => {
    recordVisit(location.pathname);
  }, [location.pathname]);

  return null;
};

export const Root = ({ children }: PropsWithChildren<{}>) => (
  <SidebarPage>
    <VisitTracker />
    <Sidebar>
      <SidebarLogo />
      <SidebarGroup label="Search" icon={<SearchIcon />} to="/search">
        <SidebarSearchModal />
      </SidebarGroup>
      <SidebarDivider />
      <SidebarGroup label="Menu" icon={<MenuIcon />}>
        {/* Global nav, not org-specific */}
        <SidebarItem icon={HomeIcon} to="/" text="Home" />
        <SidebarItem icon={LibraryBooks} to="/guide" text="Guide" />
        <SidebarItem icon={CategoryIcon} to="/catalog" text="Application" />
        {/* <MyGroupsSidebarItem
          singularTitle="My Group"
          pluralTitle="My Groups"
          icon={GroupIcon}
        /> */}
        <SidebarItem icon={CreateComponentIcon} to="catalog-import" text="Register" />
        {/* <SidebarItem icon={ExtensionIcon} to="api-docs" text="APIs" /> */}
        <RequirePermission permission={taskCreatePermission} errorPage={<></>}>
          <SidebarItem icon={CreateComponentIcon} to="create" text="Create..." />
        </RequirePermission>
        {/* End global nav */}
        <SidebarDivider />
        <SidebarScrollWrapper>
          {/* Items in this group will be scrollable if they run out of space */}
        </SidebarScrollWrapper>
      </SidebarGroup>
      <SidebarSpace />
      <SidebarDivider />
      <SidebarItem
        icon={LibraryBooks}
        text="Dashboard Dora Metric"
        onClick={() => window.open('https://internaldeveloperportal.amfs-sandbox.com/dora-metric/', '_blank')}
      />
      <SidebarItem
        icon={LibraryBooks}
        text="Resource Utilization"
        onClick={() => window.open('https://wrcapp15.axa-id.intraxa/resources-utilization/#/login', '_blank')}
      />
      {/* <NotificationsSidebarItem /> */}
      <SidebarDivider />
      <SidebarGroup
        label="Settings"
        icon={<UserSettingsSignInAvatar />}
        to="/settings"
      >
        <SidebarSettings />
      </SidebarGroup>
    </Sidebar>
    {children}
  </SidebarPage>
);

